import React from "react";
import { useSelector } from "react-redux";
import { selectAdvertisementState } from "../../store/advertisementFilterSlice";
import {
  selectAdvertisementList,
  useGetAdvertisementListQuery,
} from "../../services/advertisement/advertisementApiSlice";
import { CategoryPageSkeleton } from "../../component/skeleton/CategoryPageSkeleton";
import classes from "./advertisementPage.module.css";
import { AdvertisementFilterPage } from "./advertisementFilter/AdvertisementFilterPage";
import { AdvertisementTablePage } from "./advertisementTable/AdvertisementTablePage";

export const AdvertisementListPage = () => {
  const appliedFilters = useSelector(selectAdvertisementState);

  const { isSuccess } = useGetAdvertisementListQuery(appliedFilters);
  const tableData = useSelector(selectAdvertisementList);
  return isSuccess ? (
    <div className={classes.box}>
      <AdvertisementFilterPage filters={appliedFilters} />
      <AdvertisementTablePage data={tableData} />
    </div>
  ) : (
    <CategoryPageSkeleton />
  );
};
